export default __webpack_public_path__ + "static/media/fummiNcake_w1024.9f56b09e.jpeg";